import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    ChangeDetectorRef,
    Input
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    ActivityDaysServiceProxy,
    AllocatedMaterialDto,
    AllocateMaterialForActivityDayInput,
    UpdateAllocatedMaterialListForActivityDayInput,
} from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'app-assign-materials-table',
    templateUrl: './assign-materials-table.component.html',
    styleUrls: ['./assign-materials-table.component.less']
})
export class AssignMaterialsTableModelComponent extends AppComponentBase {
    @Input() componentMode: 'allocationSheet' | 'default' = 'default';
    @Input() allowedMaterials: any;
    @Input() allocatedMaterials: any;
    @Input() activityDayId: string;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    @Input() controlDisabled: boolean;
    @Input() anyResourceSelected: boolean;

    material:any;
    @ViewChild('materialSelectorTable') materialSelectorTable: ModalDirective;

    saving: boolean = false;

    @Output()
    onAssignedCounterUpdate: EventEmitter<number> = new EventEmitter<number>();

    public filteredMaterials: Array<any> = [];
    public currentAllocatedMaterial: any;
    constructor(
        injector: Injector,
        private _activityDaysServiceProxy: ActivityDaysServiceProxy,
        private cdr: ChangeDetectorRef
    ) {
        super(injector);
        this.material = this.allowedMaterials;
    }

    ngAfterViewInit() {
        this.setInitialMaterialsSelectorValue();
    }

    isAllocationSheet() {
        return this.componentMode === 'allocationSheet';
    }
    selectMaterial(material, selected) {
        let selectedMaterial = this.filteredMaterials.find((p) => p.id == material.id);
        selectedMaterial.selected = selected;
        if(selected){
            const params = new AllocateMaterialForActivityDayInput({
                activityDayId: this.activityDayId,
                material: new AllocatedMaterialDto({
                    actualHours: 0,
                    materialId: material.id,
                }),
            });

            this._activityDaysServiceProxy.allocateMaterial(params).subscribe(() => {
                this._activityDaysServiceProxy
                    .getMyActivityDayForEdit(this.activityDayId)
                    .subscribe((data) => {
                        this.currentAllocatedMaterial.allocatedMaterials.push({
                            materialDetails: {...material},
                            actualHours: 0,
                            materialId: material.id
                        });
                        this.updateTotals();
                        abp.event.trigger('app.evt.activityChanged');
                    });
            });
        }else{
            this._activityDaysServiceProxy
            .removeAllocatedMaterial(this.activityDayId, material.id)
            .subscribe(() => {
                this.currentAllocatedMaterial.allocatedMaterials = this.currentAllocatedMaterial.allocatedMaterials?.filter(c => c.materialId != material.id);
                this.updateTotals();
            });
        }
        this.cdr.detectChanges();
    }
    show(): void {
        this.materialSelectorTable.show();
    }

    showError(): boolean {
        const selectedMaterial = this.getSelectedMaterial();
        const total = selectedMaterial && selectedMaterial.length >0 ?selectedMaterial.map(x=>x.actualHours).reduce((a, b) => { return a + b }):0;
        return total<=0
    }

    save(): void {
        this.saving = true;
    }

    close(): void {
        this.materialSelectorTable.hide();
    }
    getSelectedMaterial() {
        return this.currentAllocatedMaterial && this.currentAllocatedMaterial.allocatedMaterials ? this.currentAllocatedMaterial.allocatedMaterials : [];
    }
    setInitialMaterialsSelectorValue() {
        this.filteredMaterials = this.allowedMaterials.map((p) => {
            let selected = this.allocatedMaterials.allocatedMaterials.some((c) => c.materialId == p.id) || false;
            return { ...p, selected,  filterShow: true};
        });
        this.currentAllocatedMaterial = { ...this.allocatedMaterials };
        this.updateTotals();
        this.cdr.detectChanges();
    }
    filteredPersonnelList(recent){
        if(recent){
            let filtered = this.filteredMaterials?.filter(p => p.wasRecentlyAssigned && p.filterShow );
            return filtered;
        }
        let filtered = this.filteredMaterials?.filter(p => p.filterShow);
        return filtered;
    }
    updateAllocatedMaterialList(event) {
        if(event.target.value){
		    if(event.target.value < 1 || event.target.value > 24) {
                this.notify.error('Hours value only allowed between 1 to 24');
                return;
            }
            const params = new UpdateAllocatedMaterialListForActivityDayInput({
                activityDayId: this.activityDayId,
                materials: [...this.currentAllocatedMaterial.allocatedMaterials].map((item) => {
                    return new AllocatedMaterialDto({
                        actualHours: item.actualHours,
                        materialId: item.materialId,
                    });
                }),
            });

            this._activityDaysServiceProxy
                .updateAllocateMaterialList(params)
                .subscribe(() => {
                    this.updateTotals();
                    abp.event.trigger('app.evt.activityChanged');
                });
        }
    }
    updateTotals() {
        let materialSum = 0;
        this.currentAllocatedMaterial.allocatedMaterials.forEach(
            (item) => (materialSum += parseInt(item.actualHours))
        );
        this.onAssignedCounterUpdate.emit(materialSum);
    }
    removeItem(materialId: string) {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._activityDaysServiceProxy
                    .removeAllocatedMaterial(this.activityDayId, materialId)
                    .subscribe(() => {
                        this.currentAllocatedMaterial.allocatedMaterials = this.currentAllocatedMaterial.allocatedMaterials?.filter(
                            (material) => material.materialId != materialId
                        );
                        var materialDetail = this.filteredMaterials.find(c=> c.id == materialId);
                        materialDetail.selected = false;
                        this.updateTotals();
                        abp.event.trigger('app.evt.activityChanged');
                    });

                this.cdr.detectChanges();
            }
        });
    }


    ClearRecent(): void {

        this._activityDaysServiceProxy.clearAllocatedMaterialRecent()
        .subscribe(() => {
            this.filteredMaterials.forEach(material => {
                material.wasRecentlyAssigned = false;
            });
        });
    }

    getMaterialDeleteToolTip(material: any): string
    {
        return this.l('DeleteMaterial') + ' ' +
        material.materialDetails.name + ' (' +
        material.materialDetails.materialId + ')';
    }

    filtersChange(filters) {
        this.filteredMaterials.forEach(f=>{
            let hide = false;
            if(filters.filterText && !(
                f.supplier && f.supplier.toLowerCase().includes(filters.filterText.toLowerCase()) ||
                f.name && f.name.toLowerCase().includes(filters.filterText.toLowerCase()) )){
                    hide = true;
            }
            if(!hide && (filters.materialName && filters.materialName.materialName && !(filters.materialName.materialName == f.name))){
                hide = true;
            }
            if(!hide && (filters.supplier && filters.supplier.supplierName && !(filters.supplier.supplierName == f.supplier))){
                hide = true;
            }

            f.filterShow = !hide;
        });
        this.cdr.detectChanges();
    }
    checkFilteredMaterialNull(data) {
        let sr = '';
        data.forEach(material=>{
            if(!material.wasRecentlyAssigned && material.filterShow) {
                sr = 'record_found';
            }
        })
        if(sr == 'record_found') {
            return false;
        } else {
            return true;
        }
    }
}
